var _path, _path2, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24.0708C16 23.0046 16.5659 22.0185 17.4865 21.4806L30.4865 13.8844C31.4215 13.338 32.5785 13.338 33.5135 13.8844L46.5135 21.4806C47.4341 22.0185 48 23.0046 48 24.0708V45C48 46.6569 46.6569 48 45 48H19C17.3431 48 16 46.6569 16 45V24.0708Z",
    fill: "#146EB4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 26,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#D0E2F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 36,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#D0E2F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 36,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#D0E2F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.35643bdceef4d6768f1e7e9d28b57178.svg";
export { ForwardRef as ReactComponent };